import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      tbv: null,
      ventas: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -30),
        hasta: this.currentdate()
      }

    };
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      "autoWidth": false,
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,

    });
    $('.box').boxWidget();

  },


  computed: {
    reporte: function () {
      return (
        "/loteip/lote/tarjetas?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.tbv.destroy();
      this.$http
        .post('/loteip/lote/tarjetas', this.f_c)
        .then(response => {

          const data = response.data.data;


          data.slice(1).forEach(e => {

            for (let i = 4; i < data[0].length; i++) {
              e[i] = this.num_to_many(parseFloat(e[i]).toFixed(2));

            }

          });

          this.tbv = $('#ventas').DataTable({
            'paging': true,
            'lengthChange': true,
            'searching': true,
            'ordering': true,
            'info': true,
            "autoWidth": false,
            'autoWidth': true,
            orderCellsTop: true,
            fixedHeader: true,
            columns: data[0].map(e => {
              return { title: e }
            }),
            data: data.slice(1)

          });
          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/posintegrado/resLotePosTarjeta/tventas/tventas.js